<script lang="ts">
	import { onMount, untrack } from 'svelte';

	// A mocked-up stopwatch that counts up once per second after hydration.
	// The prerendered value equals `start`, so there's no hydration mismatch.
	let {
		start = 0,
		pad = false,
		running = true,
		class: klass = ''
	}: { start?: number; pad?: boolean; running?: boolean; class?: string } = $props();

	// Seed from the prop's initial value only; it never changes after mount.
	let elapsed = $state(untrack(() => start));

	onMount(() => {
		if (!running) return;
		// Keep it still for anyone who's asked to reduce motion.
		if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
		const id = setInterval(() => {
			elapsed += 1;
		}, 1000);
		return () => clearInterval(id);
	});

	function fmt(total: number): string {
		const m = Math.floor(total / 60);
		const s = total % 60;
		const mm = pad ? String(m).padStart(2, '0') : String(m);
		return `${mm}:${String(s).padStart(2, '0')}`;
	}
</script>

<span class="tnum {klass}">{fmt(elapsed)}</span>
